require('../../../modules/es.array.some');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').some;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/some.js
// module id = 980
// module chunks = 0